import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

const ModalWrapper = styled.div`
  height: ${props => props.height};
  align-items: center;
  animation-delay: 0s;
  animation-duration: 0.2s;
  animation-name: modalOpacity;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;

  @keyframes modalOpacity {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .modal__box {
    animation-delay: 0s;
    animation-duration: 0.4s;
    animation-name: modalScale;
    background: #fff;
    border-radius: var(--border-radius-large);
    box-shadow: 0 2px 16px 0 rgba(#000, 0.25);
    min-height: 200px;
    min-width: 300px;
    position: relative;
    max-height: fit-content !important;

    @keyframes modalScale {
      0% {
        transform: scale(0);
      }

      30% {
        transform: scale(0.6);
      }

      60% {
        transform: scale(1.2);
      }

      100% {
        transform: scale(1);
      }
    }
  }
`;

export default class Modal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.modalRef = React.createRef();
  }

  componentDidMount() {
    const modalRoot = document.getElementById('modal-root');
    if (modalRoot) {
      modalRoot.appendChild(this.el);
      modalRoot.addEventListener('click', this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    const modalRoot = document.getElementById('modal-root');
    if (modalRoot) {
      modalRoot.removeEventListener('click', this.handleClickOutside);
      modalRoot.removeChild(this.el);
    }
  }

  handleClickOutside = e => {
    if (this.modalRef.current && !this.modalRef.current.contains(e.target)) {
      this.props.onCloseModal();
    }
  };

  render() {
    const height = '100vh';
    const { testId, className, children, dir } = this.props;
    const wrapper = (
      <ModalWrapper
        data-testid={testId}
        className="alef-assignment"
        height={height}
      >
        <div
          ref={this.modalRef}
          dir={dir}
          className={`modal__box ${className}`}
        >
          {children}
        </div>
      </ModalWrapper>
    );

    return createPortal(wrapper, this.el);
  }
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  testId: PropTypes.string,
  dir: PropTypes.string,
  onCloseModal: PropTypes.func,
};

Modal.defaultProps = {
  className: '',
  testId: 'modal-wrapper',
  dir: 'ltr',
  onCloseModal: () => {},
};
